import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPricingCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <circle cx={9} cy={9} r={7.2} fill="#C4E3E2" />
    <path
      fill="#299490"
      d="m6.769 8.869 1.125 1.106 3.037-3.019a.646.646 0 0 1 .469-.206c.175 0 .331.069.469.206a.656.656 0 0 1 0 .956L8.363 11.42a.646.646 0 0 1-.47.206.646.646 0 0 1-.468-.206L5.831 9.825a.656.656 0 0 1 0-.956.646.646 0 0 1 .469-.207c.175 0 .331.07.469.207"
    />
  </svg>
);
export default SvgPricingCheck;
